import React from 'react';

import {observer} from 'mobx-react';
import {CompetitionGamesViewModel} from "../../models/competition-games-view-model";
import {ScoresListWidgetProps} from "../../models/scores-list-widget.props";
import {ScoresListWidgetCompetitionTitle} from "./scores-list-widget.competition.title";
import {List, ListProps} from "../../../../core/components/misc/list/list";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {GameCard} from "../../../../core/components/game-card/components/game-card";
import {IntersectionObserver} from "../../../../core/components/intersection-observer/intersection-observer";
import {GameCardViewModel} from "../../../../core/components/game-card/view-models/game-card.view-model";
import {ScoresListWidgetCompetitionEmptyState} from "../empty-state/scores-list-widget.competition.empty.state";
import {GAME_CARD} from "../../../../core/components/game-card/game-card.consts";

export class ScoresListWidgetCompetitionInfoProps extends ScoresListWidgetProps {
  competition: CompetitionGamesViewModel;
  shouldRenderAd: Boolean;
  forceRender: Boolean;
  index: Number;
}

export const ScoresListWidgetCompetitionInfo = observer((props: ScoresListWidgetCompetitionInfoProps) => {
  const lineupsClickEvent = (params) => {
    props.controller.action(ACTION_TYPES.lineupsClick, params);

    return true;
  }

  const onClick = (game: GameCardViewModel) => {
    props.controller.action(ACTION_TYPES.matchDetailsClick, {
      gameId: game.id,
      competitionId: game.competitionId,
      status: game.statusGroup,
      source: APP.ANALYTICS.SOURCES[props.controller.state.currentLinkModel?.name],
      placement: APP.GOOGLE_ANALYTICS.SOURCES[props.controller.state.currentLinkModel?.name],
      currentLinkModelName: props.controller.state.currentLinkModel?.name,
      screenId: props.controller.state.currentLinkModel?.params.id,
      sportTypeId: game.sportId
    });

    return true;
  }

  const listProps: ListProps = {
    items: props.competition.games,
    ListItem: GameCard,
    itemPropName: 'game',
    listItemProps: {
      controller: props.controller,
      device: props.controller.device,
      i18n: props.controller.state.terms,
      context: GAME_CARD.CONTEXTS.allScores,
      showOdds: props.controller.state.showOdds,
      widgetName: APP.GOOGLE_ANALYTICS.SOURCES.scoresList,
      source: APP.ANALYTICS.SOURCES.scoresList,
      isFullGameCard: true,
      lineupsClickEvent: (params) => lineupsClickEvent(params),
      onClick: (...params) => onClick(...params)
    }
  }

  const competitionTitleHeight = 37;
  const gameHeight = props.controller.device.isSmallView ? 49 : 57;
  const padding = props.controller.device.isSmallView ? 8 : 16;
  const minHeight = padding + competitionTitleHeight + ((props.competition.games || [{}]).length * gameHeight);

  const intersectionObserverProps = {
    style: {
      minHeight,
    },
    forceRender: props.forceRender,
  }

  return (
    <IntersectionObserver {...intersectionObserverProps}>
      <div className={'scores-list-widget-competition-info-container'}>
        <ScoresListWidgetCompetitionTitle {...props}/>
        {
          props.competition.games.length > 0 && <List {...listProps}/>
        }
        {
          props.competition.games.length === 0 &&
          <ScoresListWidgetCompetitionEmptyState label={props.controller.state.terms.ALL_SCORES_COMPETITION_NO_GAMES}/>
        }
        {/*{*/}
        {/*  props.shouldRenderAd && <Ad {...adProps}/>*/}
        {/*}*/}
      </div>
    </IntersectionObserver>
  );
});
